import { Component, OnInit, Input } from '@angular/core';
import { DbRecord } from '../db-record'
import { Project } from '../project'
import { RuntimeService } from '../runtime.service'
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ArcService } from '../arc.service'
import { FileService } from '../file.service'

@Component({
  selector: 'app-upload-box',
  templateUrl: './upload-box.component.html',
  styleUrls: ['./upload-box.component.css']
})
export class UploadBoxComponent implements OnInit {
  @Input() dbRecord: DbRecord
  project: Project


  constructor(
    private rs: RuntimeService,
    private sanitizer: DomSanitizer,
    private arcs: ArcService,
    private fs: FileService
  ) {
    this.project = this.rs.currentProject
  }

  ngOnInit() {
  }

  get uploadId() {
    return `${this.project.shortcut}::${this.dbRecord.id}`
  }

  get isUploadForm() {
    return this.fs.isUploadForm(this.uploadId)
  }

  switchUploadForm() {
    this.fs.switchUploadForm(this.uploadId)
  }

  get files() {
    return this.fs.files(this.dbRecord.id, this.project.shortcut)
  }

  get iframe(): SafeHtml {
    return this.sanitizer.bypassSecurityTrustHtml(`
    <iframe id='uploadIFrame'
        srcdoc='
  <form method="post" enctype="multipart/form-data"
  action="https://gae-test.ecomole.com/a2">
  <input type="hidden" name="type" value="searchManagerForm">
  <input type="hidden" name="u" value="${this.arcs.userNs}">
  <input type="hidden" name="project" value="${this.project.shortcut}">
  <input type="hidden" name="idsuffix" value="${this.dbRecord.id}">
  <input type="hidden" name="parent" value="${location.protocol}//${location.host}">
  <div>
  <input type="file" id="filepicker" name="files" multiple />
  </div>
  <div>
  <button onclick="submit()">Submit</button>
  </div>
  </form>'></iframe>
  `)
  }

}



// WEBPACK FOOTER //
// /GIT/Search-manager/rating-module/src/app/upload-box/upload-box.component.ts